export default __webpack_public_path__ + "static/media/maryam-telmesani-media.838701a6.jpg";